import { useCallback, useRef, useState } from "react";
import { apiFetch } from "@/lib/auth";

/**
 * Hook para resolver un código postal MX a colonias/ciudad/estado vía
 * GET /api/postalcode. Devuelve { suggestions, lookup }.
 *
 *   const { suggestions, lookup } = useZipLookup();
 *   // al teclear el CP:
 *   const first = await lookup(zip);
 *   if (first) { setCity(first.city); setState(first.state); }
 *   // colonias sugeridas para un <datalist>:
 *   suggestions.map(s => s.neighborhood)
 */
export function useZipLookup() {
    const [suggestions, setSuggestions] = useState([]);
    const lastZip = useRef("");

    const lookup = useCallback(async (zip) => {
        const z = String(zip || "").trim();
        if (!/^\d{5}$/.test(z)) return null;
        if (z === lastZip.current) return suggestions[0] || null;
        lastZip.current = z;
        try {
            const { data } = await apiFetch.get("/postalcode", { params: { s: z } });
            const list = Array.isArray(data) ? data : [];
            setSuggestions(list);
            return list[0] || null;
        } catch {
            setSuggestions([]);
            return null;
        }
    }, [suggestions]);

    return { suggestions, lookup };
}
